import React from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';

export default function BrandsCarousel({ data }) {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className="cs_brands_arrow cs_brands_arrow_prev"
      aria-hidden="true"
      role="button"
      aria-label="Previous"
    >
      <Icon icon="mdi:chevron-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className="cs_brands_arrow cs_brands_arrow_next"
      aria-hidden="true"
      role="button"
      aria-label="Next"
    >
      <Icon icon="mdi:chevron-right" />
    </div>
  );

  const settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 5,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <Slider {...settings} className="cs_gap_20 cs_brands_carousel">
      {data?.map((item, index) => (
        <div key={index}>
          <div className="cs_brands cs_style_2">
            <img src={item.imgUrl} alt={item.imgAlt} />
          </div>
        </div>
      ))}
    </Slider>
  );
}
